
import { ChangeDetectorRef,
         Component,
         OnInit } from '@angular/core'

import { ActivatedRoute, Params, Router } from '@angular/router'

import { RouterService, User, UserService } from '../_core'
import { firstValueFrom } from 'rxjs'
import { HttpErrorResponse } from '@angular/common/http'
import { MatSnackBar } from '@angular/material/snack-bar'
// import { UserService } from '../_core/_services/user.service'


@Component({
  selector: 'app-delete-user-popup',
  templateUrl: './delete-user-popup.component.html',
  styleUrls: ['./delete-user-popup.component.scss']
})

export class DeleteUserPopupComponent implements OnInit {

  returnPathSuccess = '/admin/users'
  returnPathCancel = '../'

  queryParam$: any
  routeParam$: any
  
  selectedUser$: any
  user: User

  submitted: boolean
  isSubmitting: boolean
  isLoading: boolean

  fields = {
    type: 'warn',
    title: 'Delete?',
    helperText: null,
    warningText: 'This action cannot be undone.',
    submitText: 'Destroy!',
  }
  

  constructor(
    private cdr: ChangeDetectorRef,
    private route: ActivatedRoute,
    private router: Router,
    private routerService: RouterService,
    private userService: UserService
  ) { }

  ngOnInit() {
    this.queryParam$ = this.queryParamStream()
    this.routeParam$ = this.routeParamStream()
    this.selectedUser$ = this.selectedUserStream()
  }

  ngOnDestroy() {
    if (this.queryParam$) this.queryParam$.unsubscribe()
    if (this.routeParam$) this.queryParam$.unsubscribe()
    if (this.selectedUser$) this.selectedUser$.unsubscribe()
  }

  selectedUserStream() {
    return this.userService.selectedUser.subscribe( (user:User) => {
      this.user = user
      this.fields.helperText = user.email
      // console.log('USER', user)
      this.update()
    })
  }

  routeParamStream() {
    return this.route.paramMap.subscribe((params: Params) => {
      console.log('rt params', params['params'])
      let p = params['params']
      let id = params['id']
      if (!p['id']) return
      console.log('routeParam - id', id, params)
      // this.updateOrder(p['obfuscated_id']).then(res => {
      //   // window.setTimeout(this.initPaypal.bind(this), 500);
      // })
    })
  }
  

  queryParamStream() {
    return this.route.queryParams.subscribe(qp => {

      // let redir = qp['redir']
      // if (!redir) return

      // this.returnPathSuccess = decodeURI(redir)
      // if (this.returnPathSuccess == '') this.returnPathSuccess = null // this.defaultReturnUrl
      // console.log('redir', this.returnPath, redir)
    })
  }

  update() {
    if (!this.user) return
    this.fields['title'] = `Delete User ${ this.user.id }?`
  }

  handleSubmit($event) {
    this.isSubmitting = true;

    this.isLoading = true
    window.setTimeout(this.submitNow.bind(this), 1000)
  }

  submitNow() {
    if (!this.user) return console.log('ERR: no user!', this.user)

    firstValueFrom(this.userService.delete(this.user)).then(res => {
      this.submitted = true
      return this.handleDeleted(res)
    }).catch((err: HttpErrorResponse) => {
      // console.log('ERR: login', err)
      switch (err.status) {
        default: console.log('ERR (delete-user-popup):', err.message)
      }
      this.isLoading = false
      this.submitted = true
    })
    
  }

  handleDeleted(res: any) {
    console.log('DELETED', res)
    if (this.returnPathSuccess) return this.router.navigateByUrl(this.returnPathSuccess)

  }

  handleCancel(res: any) {
    this.routerService.closePopup()
  }

  detectChanges() {
    if (!this.cdr['destroyed']) this.cdr.detectChanges()
  }
}